import React, { useEffect } from "react";
import { useInvoice } from "../../../../../hooks/invoice/useInvoice";
import { ModalCharge } from "../../../../../shared/ModalCharge/ModalCharge";
import {
  tCommon,
  tSales,
} from "../../../../../../../../i18n/useAppTranslation";
import ViewTipsModal from "../../../../ViewTipsModal/ViewTipsModal";
import { svg } from "../../../../../../../../assets/svg";
import { useInvoiceActions } from "../../../../../hooks/useInvoiceActions";
import { InputLabel } from "../../../../../../../../shared/InputLabel/InputLabel";
import { InputCurrency } from "../../../../../../../../shared/InputCurrency/InputCurrency";
import { InputError } from "../../../../../../../../shared/InputError/InputError";
import RemainingBalanceDue from "../../../../../shared/RemainingBalanceDue/RemainingBalanceDue";

const PaymentTipsModal = ({
  isTipsApplying,
  form,
  errors,
  changeFormValue,
  isValid,
  showTipsModal,
}) => {
  const { invoice, amountToPay } = useInvoice();
  const { chargeCard } = useInvoiceActions();

  const onClose = () => {
    showTipsModal.update(false);
  };

  const handleSubmit = () => {
    return chargeCard
      .initiate({
        clearentEmail: form.email,
        clearentZip: form.zipCode,
        isSavedCard: true,
        amount: form.amount,
        clearentCardToken: form.cardOnFile.value,
      })
      .catch(onClose);
  };

  const chargeDisabled = chargeCard.isLoading || isTipsApplying || !isValid;

  useEffect(() => {
    changeFormValue("amount", amountToPay);
  }, [amountToPay]);

  return (
    <ModalCharge
      isOpen
      onClose={onClose}
      title={tSales("checkoutInvoice.paymentOptions.card")}
      imageSrc={svg.ccPrimary}
      onCharge={handleSubmit}
      isCharging={chargeCard.isLoading}
      chargeLabel={tCommon("label.charge")}
      amount={form.amount}
      isChargeDisabled={chargeDisabled}
    >
      <ViewTipsModal amountToPay={amountToPay} />
      <ModalCharge.InputWrap>
        <InputLabel>
          {tSales("checkoutInvoice.formInputLabel.amount")}
        </InputLabel>
        <InputCurrency
          size="medium"
          prefix={invoice?.currencySymbol}
          value={form.amount}
          isError={errors.amount}
          onChange={(value) => changeFormValue("amount", value)}
          placeholder={tSales("checkoutInvoice.formInputPlaceholder.amount")}
        />
        {errors.amount && <InputError>{errors.amount}</InputError>}
      </ModalCharge.InputWrap>
      <RemainingBalanceDue amount={form.amount} />
    </ModalCharge>
  );
};

export default PaymentTipsModal;
